<template>
    <div class="box">
  
      
      <a-row :gutter="24">
        <a-col :md="24">
          <a-card>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="24">
                    <a-col :md="6">
                        <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                            <a-input placeholder="请输入单据编号" v-model="queryParam.code"></a-input>
                            </a-form-item>
                        </a-col>
                        <!-- <a-col :md="6">
                            <a-form-item label="开始结束日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                <a-range-picker
                                    style="width: 100%"
                                    v-model="queryParam.date"
                                    :default-value="defaultTimeStr"
                                    format="YYYY-MM-DD"
                                    :placeholder="['开始时间', '结束时间']"
                                    @change="onDateChange"
                                />
                            </a-form-item>
                        </a-col> -->
                        <a-col :md="6">
                            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                            <a-col :md="6" :sm="24">
                                <a-button type="primary" @click="searchQuery">查询</a-button>
                                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                            </a-col>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <!-- 操作按钮区域 -->
           
  
            <!-- table区域-begin -->
            <div>
                <a-table
                    ref="table"
                    size="middle"
                    bordered
                    rowKey="uuid"
                    :columns="columns"
                    :dataSource="dataSource"
                    :pagination="ipagination"
                    @change="handleTableChange"
                >
                <template slot="state" slot-scope="state">
                  <a-tag color="red" v-if="state === 0">待审批</a-tag>
                    <a-tag color="blue" v-else-if="state === 1">审批中</a-tag>
                    <a-tag color="green" v-else-if="state === 2">审批通过</a-tag>
                    <a-tag color="red" v-else-if="state === 3">未通过审批</a-tag>
                </template>
                <template slot="source" slot-scope="source">
                  <a-tag color="red" v-if="source === 0">巡检</a-tag>
                    <a-tag color="blue" v-else-if="source === 1">冷链运输</a-tag>
                    <a-tag color="green" v-else-if="source === 2">售后</a-tag>
                    <a-tag color="red" v-else-if="source === 3">调查记录</a-tag>
                    <a-tag color="orange" v-else-if="source === 4">不良品检测</a-tag>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a @click="handleDetail(record)">查看</a>
                    <a-divider type="vertical" />
                    <!-- <a @click="handleVerify(record)">审批</a> -->
                    <a-popconfirm
                      v-if="isApproval"
                      title="是否通过审批?"
                      ok-text="通过"
                      cancel-text="关闭"
                      @confirm="() => handleAudit(record, 2)"
                      @cancel="() => handleAuditCancel(record, 3)"
                    >
                      <a :disabled="record.state === 2" :style="{ cursor: record.state === 2 ? 'not-allowed' : 'pointer', opacity: record.state === 2 ? 0.5 : 1 }">审批</a>
                    </a-popconfirm>
                    <!-- <a-divider type="vertical" />
                    <a @click="handleDelete(record)">删除</a> -->
                </template>
                </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- 新增/编辑区域 -->
      <!-- <approveDetail ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></approveDetail> -->
      <!-- 巡检详情 -->
      <rout-detail ref="getroutDetail" @ok="routDetailOk" @close="routDetailClose"></rout-detail> 
      <!-- 冷链运输详情 -->
      <code-detail ref="getcodeDetail" @ok="routDetailOk" @close="routDetailClose"></code-detail>
      <!-- 售后详情 -->
      <after-detail ref="getAfterDetail" @ok="routDetailOk" @close="routDetailClose"></after-detail>
      <!-- 质量事故报告详情 -->
      <quality-detail ref="getQualityDetail" @ok="routDetailOk" @close="routDetailClose"></quality-detail>
      <!-- 不良事故报告详情 -->
      <adverse-detail ref="getAdverseDetail" @ok="routDetailOk" @close="routDetailClose"></adverse-detail>
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { getApproveList, deleteService, editApprovalState, getSpotDetail, getCodeDetail, getAfterDetail, getQualityDetail, getAdverseDetail } from '@/api/api'
    import approveDetail from './modules/approveDetail'
    import RoutDetail from '@/views/Camp/modules/routDetail'
    import CodeDetail from '@/views/Camp/modules/codeDetail'
    import AfterDetail from '@/views/Camp/modules/afterDetail'
    import QualityDetail from '@/views/Camp/modules/qualityDetail'
    import AdverseDetail from '@/views/Camp/modules/adverseDetail'
    export default {
      name: "list",
      mixins:[JeecgListMixin],
      components: {
        approveDetail,
        RoutDetail,
        CodeDetail,
        AfterDetail,
        QualityDetail,
        AdverseDetail
      },
      data() {
        return {
          current: ['enterpriseRule'], // 顶部导航栏
          bindInfo:{},
          // 查询区域布局
          labelCol: {
            span: 5
          },
          wrapperCol: {
            span: 18,
            offset: 1
          },
          isApproval: true, // 控制是否显示审批确认框
          // 查询条件
          queryParam: {},
          menuItems: [],
          dropdownStates: {},
          dropdownVisible: false, // 控制下拉框的显示状态
          // 表头
          columns: [
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width: '50px',
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
                title: '审核结果', 
                dataIndex: 'state', 
                align:"center", 
                scopedSlots: { customRender: 'state' },render: (text) => text || "--",
                sorter: (a, b) => a.state - b.state
            },
            {
                title: '单据编号', 
                dataIndex: 'code', 
                align:"center",
                sorter: (a, b) => a.code.localeCompare(b.code),
            },
            {
                title: '单据来源', 
                dataIndex: 'source', 
                align:"center",
                scopedSlots: { customRender: 'source' },render: (text) => text || "--",
                sorter: (a, b) => a.source.localeCompare(b.source),
            },
            {
                title: '创建人', 
                dataIndex: 'createBy', 
                align:"center",
                sorter: (a, b) => a.createBy.localeCompare(b.createBy),
            },
            {
                title: '创建时间', 
                dataIndex: 'createTime', 
                align:"center",
                sorter: (a, b) => a.createTime.localeCompare(b.createTime),
            },
            {
                title: '审批人', 
                dataIndex: 'approver', 
                align:"center",
                sorter: (a, b) => a.approver.localeCompare(b.approver),
            },
            {
                title: '审批时间',
                dataIndex: 'approvalTime',
                align:"center",
                sorter: (a, b) => new Date(a.approvalTime) - new Date(b.approvalTime),
            },
            // {
            //     title: '审核备注', 
            //     dataIndex: 'reviewRemark', 
            //     align:"center",
            //     sorter: (a, b) => a.reviewRemark.localeCompare(b.reviewRemark),
            // },
            {
                title: '操作',
                dataIndex: 'action',
                align:"center",
                scopedSlots: { customRender: 'action' },
                width: '250px'
            }
            
          ],
          dataSource:[],
          // 控制列的显示状态
          columnVisibility: {
            codeRuleId: false, // 设置为 false 隐藏该列
            formTemplateId: false, // 设置为 false 隐藏该列
            proceCode: false
          },
        ipagination: {
            current: 1,
            pageSize: 10,
            total: 0,
            showTotal: (total) => `共 ${total} 条`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30'],
            onShowSizeChange: (current, pageSize) => this.onShowSizeChange(current, pageSize),
        },
        url: {
          list: '', ///quality/afterSales/list
        },
        }
      },
      mounted() {
        this.getApproveList();
      },
      methods: {
        
        // 获取售后列表
        async getApproveList(){
          
          const params = {
            licenceType: 3,
            source: this.queryParam.source || '',
            code: this.queryParam.code || '',
            date: this.queryParam.date || '',
            pageSize: this.ipagination.pageSize,
            pageNo: this.ipagination.current
          }
          const res = await getApproveList(params)
          if(  res.code == 200 && res.success == true ){
            console.log(res,'售后服务res====================')
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          } else {
            this.$message.warning(res.message)
          }
        },
        getColor(state) {
            if ( state == 1 ) return '处理中'
            else if ( state == 2 ) return '上传成功'
            else if ( state == 3 ) return '上传失败'
            else return '未知状态'
        },
        handleTableChange(pagination, filters, sorter) {
            this.ipagination = pagination;
            this.getApproveList();
        },
        searchQuery() {
            console.log('查询条件:', this.queryParam);
            this.getApproveList();
        },
        searchReset() {
            this.queryParam = {};
            this.getApproveList();
        },
        onShowSizeChange(current, pageSize) {
            this.ipagination.current = current;
            this.ipagination.pageSize = pageSize;
            // 重新获取数据或处理分页逻辑
        },
        
        modalFormOk(){
          this.loadData(1)
        },
        // 上传
        async uploadOrder(record){
          const params = {
            recordId: record.id
          }
          const res = await traceSaveForEventId(params)
          if(  res.code == 200 && res.success == true ){
            this.$message.success(res.message)
            this.getApproveList()
          } else {
            this.$message.warning(res.message)
          }
        },
        handleAudit(record, state){
          const params = {
            uuid: record.uuid,
            state: state, // 2 表示通过
          };
          editApprovalState(params).then(res => {
            if (res.code == 200 && res.success == true) {
              this.$message.success(res.message);
              this.getApproveList(); // 刷新列表
            } else {
              this.$message.error(res.message);
            }
          });
        },
        handleAuditCancel(){
          // 关闭a-popconfirm


        },
        // 查看详情
        async handleDetail(record){
          if( record.source === 0 ){
            // 巡检详情
            const res = await getSpotDetail({id:record.licenceId})
            if( res.code == 200 && res.success == true ){
              this.$refs.getroutDetail.show(res.result)
            } else {
              this.$message.warning(res.message)
            }
          } else if( record.source === 1 ){
            // 冷链运输详情
            const res = await getCodeDetail({id:record.licenceId})
            if( res.code == 200 && res.success == true ){
              this.$refs.getcodeDetail.show(res.result)
            } else {
              this.$message.warning(res.message)
            }
          } else if( record.source === 2 ){
            const res = await getAfterDetail({id:record.licenceId})
            if( res.code == 200 && res.success == true ){
              this.$refs.getAfterDetail.show(res.result)
            } else {
              this.$message.warning(res.message)
            }
            // 售后详情
          } else if( record.source === 3 ){
            // 质量事故调查详情
            const res = await getQualityDetail({id:record.licenceId})
            if( res.code == 200 && res.success == true ){
              this.$refs.getQualityDetail.show(res.result)
            } else {
              this.$message.warning(res.message)
            }
          } else if( record.source === 4 ){
            // 不良事件详情
            const res = await getAdverseDetail({id:record.licenceId})
            if( res.code == 200 && res.success == true ){
              this.$refs.getAdverseDetail.show(res.result)
            } else {
              this.$message.warning(res.message)
            }
          }
          

        },
        // 审核
        async handleVerify(record){
            this.$confirm('是否通过审核', '确认操作', {
                confirmButtonText: '通过',
                cancelButtonText: '关闭',
            }).then(() => {
                const params = {
                    uuid: record.uuid,
                    state: 2,
                }
                editApprovalState(params).then(res => {
                    if ( res.code == 200 && res.success == true ) {
                        this.$message.success(res.message)
                        this.getApproveList()
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {});
          
        },
        // 删除
        handleDelete(record){
          this.$confirm('是否确定删除', '确认操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.deleteService(record)
          }).catch(() => {});
        },
        async deleteService(record){
          const params = {
            id: record.id
          }
          const res = await deleteService(params)
          if( res.code == 200 && res.success == true ) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.error(res.message)
          }
        }
      },
    }
  </script>
  
  <style scoped>
  
  </style>